<div
  role="link"
  tabindex="0"
  attr.aria-labelledby="folder-name"
  (activate)="handleClick($event)"
  class="grid-row wrapper"
  [ngClass]="{ bundle: checkAccessGroups() }"
>
  <div
    class="text-contained inline-flex"
    id="folder-name"
    attr.aria-label="{{ folder?.getName() }} Folder"
  >
    <i class="fas fa-folder icon"></i>
    {{ folder?.getName() }}
  </div>
  <div
    class="text-contained timestamp"
    id="folder-updated"
    attr.aria-label="Last updated {{ timestampAge }}"
  >
    {{ timestampAge }}
  </div>
  <div class="empty"></div>
  <div class="toggleBundle" *ngIf="checkAccessGroups()">
    <clark-toggle-switch
      [state]="getFolderBundleStatus(folder)"
      (click)="$event.stopPropagation()"
      (toggled)="handleBundleToggle(folder, $event)"
    ></clark-toggle-switch>
  </div>
  <a
    tabindex="0"
    attr.aria-label="Clickable Option Menu for {{ folder?.getName() }}"
    *ngIf="showOptionButton"
    class="meatballs"
    (activate)="handleMeatballClick($event)"
  >
    <div></div>
  </a>
</div>
